import State from 'interfaces/state/State';

export const billing$ = (state: State) => state.billing.billing;
export const isLoading$ = (state: State) => state.billing.isLoading;
export const isError$ = (state: State) => state.billing.isError;
